import { createFileRoute } from '@tanstack/react-router';
import ContactView from '../../../features/baseData/contacts/contact/view';
import {
  CONTACTS_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/kontakte/$contactId')({
  component: ContactView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(CONTACTS_PERMISSIONS, 'READ'),
  ),
});

export const ViewContactRoute = Route;
